import React from 'react';
import { useLocation } from 'react-router-dom';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { get, SiteConfigManager, useApplicationState } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Icon, PinButton } from '@atlas/ui';
import useIsSwipeGrid from 'src/common/Widgets/Tournament/useIsSwipeGrid';

const MenuItemFavoriteExpand = ({
  dataTestId,
  dataTestItemId,
  icon,
  isExpanded,
  isFavorite,
  mainLabel,
  setFavorite,
  subLabel = '',
  toggleExpanded,
}) => {
  const { pathname } = useLocation();
  const applicationState = useApplicationState();
  const isSwipeGrid = useIsSwipeGrid();
  const authenticated = get(applicationState, 'authenticated');
  const resolved = get(applicationState, 'resolved');

  const sportLivePath = SiteConfigManager.getComponentPath(COMPONENT_TYPES.SPORT_LIVE);
  const isLive = pathname.includes(sportLivePath);

  const arrowClassName = cx({
    down: !isExpanded,
    up: isExpanded,
  });

  const iconArrowClassName = cx(`arrow-${arrowClassName}`);

  const menuItemClassName = cx('menu-item-container sport', {
    active: isExpanded,
    swipe: isSwipeGrid,
  });

  return (
    <div className={menuItemClassName} data-test-item-id={dataTestItemId} data-testid={dataTestId}>
      <div className="menu-item-icon">{icon}</div>
      <div className="menu-item-text" onClick={toggleExpanded}>
        <h3 className="main-label">{mainLabel}</h3>
        {subLabel && <span className="sub-label">{subLabel}</span>}
      </div>

      <div className="menu-item-icon-controls">
        {resolved && authenticated && !isLive && (
          <div className="font-icon-container">
            <PinButton active={isFavorite} onClick={setFavorite} />
          </div>
        )}
        <div className="font-icon-container">
          <Icon className={iconArrowClassName} name={iconArrowClassName} onClick={toggleExpanded} />
        </div>
      </div>
    </div>
  );
};

MenuItemFavoriteExpand.propTypes = {
  icon: PropTypes.node.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  isFavorite: PropTypes.bool.isRequired,
  mainLabel: PropTypes.string.isRequired,
  setFavorite: PropTypes.func.isRequired,
  subLabel: PropTypes.string,
  toggleExpanded: PropTypes.func.isRequired,
};

export default MenuItemFavoriteExpand;
